/* Single source of truth for resolving the backend base URL.
 *
 * Strategy (avoids cross-origin cookie loss in production custom domains):
 * - In the browser → use same-origin ("") so calls hit /api on whatever
 *   domain the user is currently on (preview, *.emergent.host, or any
 *   custom domain like app.cemedeiros.com.br). Cookies stay first-party.
 * - On the server side (SSR/Node, build scripts, tests) → fall back to
 *   the compiled REACT_APP_BACKEND_URL.
 */
export const BACKEND_URL =
  typeof window !== "undefined"
    ? ""
    : process.env.REACT_APP_BACKEND_URL || "";
